/* eslint-disable no-undef */
import { cloneDeep } from "lodash";
import store from "@/store";
import axios from "axios";
import util from "@/libs/util";
import Setting from "@/settings";
import { Message } from "element-ui";

function showErrorMessage(message, type = "error") {
  Message({
    message: message,
    type: type
  });
}

function getBaseUrl() {
  var tenant = store.state.admin.account.tenant;
  // console.log(">>>>>> tenant111111111 >>>>>>", tenant);
  if (tenant === "") {
    Message({ message: "租户信息获取失败", type: "error" });
    throw new Error("租户信息获取失败");
  }
  var baseURL = `${Setting.apiBaseURL}`;
  var str = baseURL.replace(/\$\{tenant\}/, tenant);
  // console.log(">>>>>> str222222222222 >>>>>>", str);
  return str;
}

function xGetBaseUrl() {
  var baseURL = `${Setting.apiBaseURL}`;
  // console.log(">>>>>> xGetBaseUrl >>>>>>", baseURL);
  return baseURL;
}

function yGetBaseUrl() {
  var baseURL = `${Setting.xApiBaseURL}`;
  return baseURL;
}

//
function IsLoginByToken() {
  var uuid = util.cookies.get("uuid");
  return uuid && uuid !== "undefined" ? uuid : "";
}


//
const service = axios.create({
  baseURL: "",
  timeout: 120000,
  withCredentials: true
});

//
service.interceptors.request.use(
  config => {
    // console.log(">>>>>> ???? config >>>>>>", config);
    if (!config.url.startsWith("http")) {
      let baseUrl = null;
      if (config.method == "post" && config.xurl == "xurl") {
        baseUrl = yGetBaseUrl();
      }
      else {
        baseUrl = getBaseUrl();
        // console.log(">>>>>> 嘻嘻嘻 >>>>>>", baseUrl);
      }

      // console.log(">>>>>> ！！！！ >>>>>>", baseUrl);
      baseUrl = baseUrl.endsWith("/") ? baseUrl : baseUrl + "/";
      let apiUrl = config.url.startsWith("/") ? config.url.substring(1, config.url.length) : config.url;
      config.url = baseUrl + apiUrl;
    }
    else {
      if (config.method == "get") {
        // console.log(">>>>>> config >>>>>>", config);
        config.url = config.url.replace(Setting.tenantCode + '/', "");
        if (config.Paras != null) {
          let str = "";
          for (let key in config.Paras) {
            str += ("&" + key + "=" + config.Paras[key]);
          }
          if (str != "")
            str = "?" + (str.substring(1));
          config.url = config.url + str;
        }
        // console.log(">>>>>> config >>>>>>",config);
      }
      else if (config.method == "post") {
        // console.log(">>>>>> xpost1 >>>>>>", config);
        let baseUrl = null;
        if (config.xurl == "xurl") {
          baseUrl = yGetBaseUrl();
        }
        else {
          baseUrl = xGetBaseUrl();
        }
        baseUrl = baseUrl.endsWith("/") ? baseUrl : baseUrl + "/";
        // config.url = config.url.replace(Setting.tenantCode+'/', "");
        // config.headers["Content-Type"]="text/plain";//application/x-www-form-urlencoded
        // config.headers["accept"]="text/plain";
        // console.log(">>>>>> xpost2 >>>>>>", config);
      }
    }

    return config;
  },
  error => {
    //
    console.log(error);
    return Promise.reject(error);
  }
);

// response 响应拦截器
service.interceptors.response.use(
  response => {

    //响应拦截器-特殊函数
    funFilResponse(response);

    //
    if (response.config.responseType === "blob") {
      if (response.data.type == 'application/json') {
        return new Promise((resolve) => {
          const reader = new FileReader(); 聽
          reader.readAsText(response.data, 'utf-8');
          reader.onload = function () {
            resolve(JSON.parse(reader.result));
          }
        });
      } else {
        //
        const disposition = response.headers["content-disposition"];
        if (disposition && disposition.indexOf("filename") !== -1) {
          const fileName = decodeURI(disposition.split("filename*=UTF-8''")[1]);
          return Promise.resolve({ success: true, data: response.data, fileName: fileName });
        }
        return Promise.resolve(response.data);
      }



    } else {
      const res = response.data;
      const { code, success } = res;
      if (code === undefined || success === undefined) {
        //
        showErrorMessage("接口返回数据不满足UI要求");
      }
      return res;
    }
  },
  async error => {
    console.log(error);
    let res = { success: false, code: 0, message: "" };
    if (error.response) {
      var data = error.response.data;
      if (_.isPlainObject(data)) {
        res = {
          success: false,
          code: error?.response?.data?.status
            ? error?.response?.data?.status
            : 0,
          message: error.message,
          ...error.response.data
        };
        //console.log(res);
      } else if (_.isString(data)) {
        if (_.isNumber(error.response.status)) {
          res.code = error.response.status;
        }
        res.message = data || error.response.statusText;
      }
    } else {
      res.message = error.message;
    }

    //
    if (res.code == 401) {
      console.log("request-401")
      if (IsLoginByToken() != "") {
        Setting.SetIdeExpired = 1;
        if (document.getElementById("exitBtn")) {
          //document.getElementById("exitBtn").click();
        }
      }

      if (res.message.length > 3) {
        if (res.message.substring(0, 3) == "未登录") {
          window.location.href = "/login";
        }
      }

    }

    //错误信息拦截
    if (res.message) {
      if (res.message.indexOf("等待后台检查程序恢复后方可使用") > 0) {
        res.message = "【主库】状态不可用";
      }
    }


    return res;
  }
);

//
function funFilResponse(resParas) {

  //
  if (resParas.config.url.indexOf("/system/auth/login") > 0 ||
    resParas.config.url.indexOf("system/auth/GetUserInfo") > 0
  ) {
    //
    clearTimeout(Setting.loopConfig.setTimNum);
    Setting.loopConfig.setTimNum = 0;
    // 修改时间：2026-07-04  修改人：lc  修改内容：在线心跳接口不参与自动登出，默认关闭以避免产生大量冗余访问日志
    if (Setting.loopConfig.enableOnlineHeartbeat === true) {
      Setting.loopConfig.setTimNum = setTimeout(() => { exeUpdOnline(resParas.config); }, 3000);
    }
  }

  //滑动过期-登录后的内页点击
  if (Setting.RefrashState == 1) {
    refrashToken(resParas.config);
  }
}

//
//
function exeUpdOnline(reqConfig) {

  //
  if (Setting.loopConfig.enableOnlineHeartbeat !== true) {
    return;
  }
  if (Setting.loopConfig.reqState == 0) {
    Setting.loopConfig.reqState = 1;
    //
    service.post(`api/v1/system/user/UpdOnline`, {})
      .then(function (response) {
        Setting.loopConfig.reqState = 0;
        if (response.success && response.code == 1) {
          //自调用
          clearTimeout(Setting.loopConfig.setTimNum);
          Setting.loopConfig.setTimNum = setTimeout(() => { exeUpdOnline(); }, Setting.loopConfig.loopTime);
        }
      })
      .catch(function (error) {
        Setting.loopConfig.reqState = 0;
      });
  }

}

//
var refrashToken = async (reqConfig) => {
  if (!reqConfig || !reqConfig.url) {
    return;
  }
  if (reqConfig.url.indexOf("system/auth/GetUserInfo") >= 0 ||
    reqConfig.url.indexOf("system/user/UpdOnline") >= 0 ||
    reqConfig.url.indexOf("system/auth/Login") >= 0 ||
    reqConfig.url.indexOf("system/auth/login") >= 0
  ) {
    return;
  }
  var iNowTime = new Date().getTime();
  var ilstRefrash = cloneDeep(Setting.lstRefrash);
  var ilstRefrashTim = ilstRefrash.clickTime;
  var refreshInterval = Setting.sessionRefreshInterval || 20 * 60 * 1000;
  if (iNowTime - ilstRefrashTim > refreshInterval && ilstRefrash.reqState == 0) {
    Setting.lstRefrash.reqState = 1;
    Setting.lstRefrash.clickTime = iNowTime;
    try {
      await store.dispatch("admin/account/getLoginInfo");
    } finally {
      Setting.lstRefrash.reqState = 0;
    }
  }
};
export default service;
